/**
 *    SPDX-License-Identifier: Apache-2.0
 */

import { combineReducers } from 'redux';
import types from './types';

const initialState = {};

const blockListReducer = (state = initialState, action = {}) => {
  if (action.type === types.BLOCK_LIST) {
    return {
      rows: action.payload.rows,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const blockListSearchReducer = (state = initialState, action = {}) => {
  if (action.type === types.BLOCK_LIST_SEARCH) {
    return {
      rows: action.payload.rows,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const blockListSearchParamsReducer = (state = initialState, action = {}) => {
  if (action.type === types.BLOCK_LIST_SEARCH_PARAMS) {
    return {
      params: action.payload,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const chaincodeListReducer = (state = initialState, action = {}) => {
  if (action.type === types.CHAINCODE_LIST) {
    return {
      rows: action.payload.chaincode,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const channelsReducer = (state = initialState, action = {}) => {
  if (action.type === types.CHANNELS) {
    return {
      rows: action.payload.channels,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }

};

const peerListReducer = (state = initialState, action = {}) => {
  if (action.type === types.PEER_LIST) {
    return {
      rows: action.payload.peers,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const transactionReducer = (state = initialState, action = {}) => {
  if (action.type === types.TRANSACTION) {
    return {
      transaction: action.payload.row,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const transactionListReducer = (state = initialState, action = {}) => {
  if (action.type === types.TRANSACTION_LIST) {
    return {
      rows: action.payload.rows,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const transactionListSearchReducer = (state = initialState, action = {}) => {
  if (action.type === types.TRANSACTION_LIST_SEARCH) {
    return {
      rows: action.payload.rows,
      params: action.payload.params,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const transactionListSearchParamsReducer = (state = initialState, action = {}) => {
  if (action.type === types.TRANSACTION_LIST_SEARCH_PARAMS) {
    return {
      params: action.payload,
      loaded: true,
      errors: action.error,
    };
  } else {
    return state;
  }
};

const reducer = combineReducers({
  blockList: blockListReducer,
  blockListSearch: blockListSearchReducer,
  blockListSearchParams: blockListSearchParamsReducer,
  chaincodeList: chaincodeListReducer,
  channels: channelsReducer,
  peerList: peerListReducer,
  transaction: transactionReducer,
  transactionList: transactionListReducer,
  transactionListSearch: transactionListSearchReducer,
  transactionListSearchParams: transactionListSearchParamsReducer,
});

export default reducer;
